import React, { useState } from "react";

import Navbar from "../common/Navbar";
import Cookie from "../common/Cookies";
import CustomAutoComplete from "../common/AutoCompleteCustom";
import Button from "../common/Button";
import ConnectionFinder from "../../api/ConnectionFinder";
import Loading from "../common/Loading";
import NavButton from "../common/NavButton";

import FibercopResult from "../research/TotalResearch/FibercopResult";
import OpenfiberResult from "../research/TotalResearch/OpenfiberResult";
import FibreconnectResult from "../research/TotalResearch/FibreconnectResult";
import UnidataResult from "../research/TotalResearch/UnidataResult";

import fcLogo from "../img/FiberCopLogoWhite.png";
import ofLogo from "../img/OpenFiberLogoWhite.png";
import fibreconnectLogo from "../img/FibreConnect.svg";
import unidataLogo from "../img/unidatalogo.png";

import "../styles/Fibre.css";
import "../styles/Total.css";

const renderStatusBadge = (isConnected) => {
    return isConnected ? (
        <div className="statusBadge statusBadgeConnected">
            <span className="statusBadgeConnectedDot"></span>
            Coperto
        </div>
    ) : (
        <div className="statusBadge statusBadgeNotConnected">
            Non Disponibile
        </div>
    );
};

const TotalResearch = () => {
    const [cities, setCities] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const [civics, setCivics] = useState([]);

    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [civic, setCivic] = useState("");

    const [results, setResults] = useState(
        <div className="resultPlaceholder">
            Seleziona comune e indirizzo per avviare la ricerca.
        </div>
    );


    const clearOptionsFor = (labels) => {
        const options = {
            comune: () => {
                setCities([]);
                setCity("");
            },
            indirizzo: () => {
                setAddresses([]);
                setAddress("");
            },
            civico: () => {
                setCivics([]);
                setCivic("");
            },
        };

        labels.forEach(label => {
            if (options[label]) options[label]();
        });
    };

    const getCities = (city) => {
        if (city.length === 0) clearOptionsFor(['comune', 'indirizzo', 'civico']);
        if (city.length !== 3) return;

        ConnectionFinder.get("/research/total/cities", {
            headers: { "x-access-token": localStorage.getItem('token') },
            params: { name: city }
        }).then((response) => {
            setCities(sortByLength(response.data, 'Denominazione_in_italiano'));
        });
    };

    const getAddresses = (address) => {
        const cityVal = document.getElementById("comune")?.value || "";

        if (cityVal.length === 0) return alert("Compila prima il campo comune!");

        if (address.length === 0) clearOptionsFor(['indirizzo', 'civico']);
        if (address.length !== 3) return;

        ConnectionFinder.get("/research/total/addresses", {
            headers: { "x-access-token": localStorage.getItem('token') },
            params: { city: cityVal, address }
        }).then((response) => {
            setAddresses(response.data);
        });
    };

    const getEgon = (address, addrList) => {
        let egon = "0";
        addrList.forEach(element => {
            if (element.address === address) {
                egon = element.egon;
            }
        });
        return egon;
    };

    function sortByLength(array, property) {
        return array.sort((x, y) => x[property].length - y[property].length);
    }

    const getCivics = (civic) => {
        const cityVal = document.getElementById("comune")?.value || "";
        const addressVal = document.getElementById("indirizzo")?.value || "";

        if (addressVal.length === 0) return alert("Compila prima il campo indirizzo!");

        if (civic.length === 0) clearOptionsFor(['civico']);
        if (civic.length !== 1) return;

        ConnectionFinder.get("/research/total/civics", {
            headers: { "x-access-token": localStorage.getItem('token') },
            params: { city: cityVal, address: getEgon(addressVal, addresses), civic }
        }).then((response) => {
            setCivics(response.data.sort());
        });
    };

    const getResults = (overrideCivic = null) => {
        const cityVal = document.getElementById("comune")?.value || "";
        const addressVal = document.getElementById("indirizzo")?.value || "";
        let civicVal = document.getElementById("civico")?.value || "";

        if (overrideCivic !== null) {
            civicVal = overrideCivic;
            setCivic(overrideCivic);
            const civInput = document.getElementById("civico");
            if (civInput) civInput.value = overrideCivic;
        }

        if (cityVal.length === 0 || addressVal.length === 0) return alert("Compila i campi obbligatori!");

        setResults(<Loading />);

        ConnectionFinder.get("/research/total/results", {
            headers: { "x-access-token": localStorage.getItem('token') },
            params: { city: cityVal, address: addressVal, egon: getEgon(addressVal, addresses), civic: civicVal }
        }).then((response) => {
            const data = response.data;
            setResults(
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {/* FiberCop */}
                    <div className="providerCard">
                        <div className="providerCardHeader">
                            <div className="providerCardBrand">
                                <img src={fcLogo} alt="FiberCop" className="providerCardLogo" />
                                <h3 className="providerCardTitle">FiberCop</h3>
                            </div>
                            {renderStatusBadge(data.FC?.is_connected)}
                        </div>
                        {data.FC?.is_connected && (
                            <div className="providerCardBody">
                                <FibercopResult data={data} address={addressVal} onSelectCivic={(c) => getResults(c)} />
                            </div>
                        )}
                    </div>

                    {/* Open Fiber */}
                    <div className="providerCard">
                        <div className="providerCardHeader">
                            <div className="providerCardBrand">
                                <img src={ofLogo} alt="Open Fiber" className="providerCardLogo" />
                                <h3 className="providerCardTitle">Open Fiber</h3>
                            </div>
                            {renderStatusBadge(data.OF?.is_connected)}
                        </div>
                        {data.OF?.is_connected && (
                            <div className="providerCardBody">
                                <OpenfiberResult data={data} civic={civicVal} />
                                {data.OF?.details?.records?.length > 1 && (
                                    <div className="civicListContainer">
                                        <h4 className="civicListHeader">Civici e Scale Trovate ({data.OF.details.records.length})</h4>
                                        <ul className="civicList">
                                            {data.OF.details.records.map((item, index) => {
                                                const coords = item.COORDINATE_BUILDING ? item.COORDINATE_BUILDING.replace("_", "") : null;
                                                return (
                                                    <li key={index} className="civicListItem">
                                                        <span>{addressVal} {item.CIVICO} {item.SCALA_PALAZZINA ? `(Scala ${item.SCALA_PALAZZINA})` : ''}</span>
                                                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                            {coords && (
                                                                <a
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    href={`https://www.google.com/maps/search/?api=1&query=${coords}`}
                                                                    className="mapsLinkBtn"
                                                                >
                                                                    Google Maps ↗
                                                                </a>
                                                            )}
                                                            <button
                                                                className="searchCivicBtn"
                                                                onClick={() => getResults(item.CIVICO)}
                                                            >
                                                                Cerca Civico
                                                            </button>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* FibreConnect */}
                    <div className="providerCard">
                        <div className="providerCardHeader">
                            <div className="providerCardBrand">
                                <img src={fibreconnectLogo} alt="FibreConnect" className="providerCardLogo" />
                                <h3 className="providerCardTitle">FibreConnect</h3>
                            </div>
                            {renderStatusBadge(data.FibreConnect?.is_connected)}
                        </div>
                        {data.FibreConnect?.is_connected && (
                            <div className="providerCardBody">
                                <FibreconnectResult data={data} />
                            </div>
                        )}
                    </div>

                    {/* Unidata */}
                    <div className="providerCard">
                        <div className="providerCardHeader">
                            <div className="providerCardBrand">
                                <img src={unidataLogo} alt="Unidata" className="providerCardLogo" />
                                <h3 className="providerCardTitle">Unidata</h3>
                            </div>
                            {renderStatusBadge(data.Unidata?.is_connected)}
                        </div>
                        {data.Unidata?.is_connected && (
                            <div className="providerCardBody">
                                <UnidataResult data={data} address={addressVal} onSelectCivic={(c) => getResults(c)} />
                            </div>
                        )}
                    </div>
                </div>
            );
        });
    };


    return (
        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #111827 100%)', paddingBottom: '40px', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ width: '100%' }}>
                <Navbar />
            </div>
            <div className="totalResearchContainer">
                <div className="totalResearchFormColumn">
                    <NavButton text="Indietro" to="/home" />
                    <div className="totalResearchForm">
                        <h2 className="totalResearchFormTitle">Ricerca Generale</h2>
                        <CustomAutoComplete
                            suggestions={cities.map((cityItem) => cityItem.Denominazione_in_italiano.toUpperCase())}
                            value={city}
                            setvalue={setCity}
                            onTextChange={(e) => getCities(e.target.value)}
                            sx={{ marginTop: '10px' }}
                            disableClearable
                            label="Comune*"
                            id="comune"
                            className="AutoCompleteFibre"
                        />
                        <CustomAutoComplete
                            suggestions={addresses.map((addr) => addr.address)}
                            value={address}
                            setvalue={setAddress}
                            onTextChange={(e) => getAddresses(e.target.value)}
                            sx={{ marginTop: '10px' }}
                            disableClearable
                            label="Indirizzo*"
                            id="indirizzo"
                            className="AutoCompleteFibre"
                        />
                        <CustomAutoComplete
                            suggestions={civics.map((civicItem) => civicItem.civic)}
                            value={civic}
                            setvalue={setCivic}
                            onTextChange={(e) => getCivics(e.target.value)}
                            sx={{ marginTop: '10px' }}
                            disableClearable
                            label="Civico"
                            id="civico"
                            className="AutoCompleteFibre"
                        />
                        <Button name="Cerca" style={{ marginTop: '16px', width: '100%' }} func={() => getResults()} />
                    </div>
                </div>

                <div className="totalResearchResults">
                    <div className="resultTitle">
                        <span>Risultati Copertura</span>
                    </div>
                    {results}
                </div>
            </div>
            <Cookie />
        </div>
    );
};

export default TotalResearch;